export default "__VITE_ASSET__Dj9BHush__"